// Module
var code = "<div class=\"item text-center\" ng-class=\"{'active': active}\" ng-transclude=\"\"></div>";
// Exports
module.exports = code;